import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutContext } from '../../../contexts/layout.context';
import { useDispatch } from 'react-redux';
import actions from '../../../store/actions';

import Head from '../../../components/Head/Head';
import BirthdayForm from '../../../components/Profile/Edit/BirthdayForm/BirthdayForm';

const EditBirthday = () => {
  const { setLayout } = useContext(LayoutContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Зміна | New Brain';
    setLayout({ page: 'Зміна' });
  }, [setLayout]);

  const goBack = () => {
    navigate('/profile');
    dispatch(actions.profile.profileError({}));
  };

  return (
    <div className="profile container">
      <Head textHead='Зміна дати народження' goBack={goBack} />
      <div className="profile__content">
        <BirthdayForm />
      </div>
    </div>
  );
};

export default EditBirthday;